import {Injectable} from '@angular/core';
import {PctConfigModel} from '../../models/pct-config/pct-config.model';
import {from, Observable} from 'rxjs';
import {PctConfigService} from "./pct-config.service";
import {SqliteRemConfigRepository} from "../../sqllite/repositories/rem-configs/sqlite-pct-config.repository";

@Injectable()
export class StandalonePctConfigService extends PctConfigService {

    constructor(private readonly sqliteRemConfigRepository: SqliteRemConfigRepository) {
        super();
    }

    public findRemConfigByCountryAndRole() : Observable<PctConfigModel[]>{
        return from(this.sqliteRemConfigRepository.getPctConfigs());
    }

}
